<template>
  <PageView :loading class="bg-light" header-class="bg-light">
    <!-- <ScrollDownIndicatorComponent ref="scrollDownIndicator" /> -->
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title text-center">{{ activeParticipations.length > 1 ? 'Mes événements à venir' : 'Mon événement à venir' }}</h4>
              <div class="card-text text-center text-md-start d-flex flex-wrap"
                v-if="activeParticipations.length > 0">
                <div class="col-12 col-md-6 col-lg-4 col-xl-3 my-2 m-md-0 d-flex flex-wrap p-2" v-for="participation in activeParticipations" :key="participation.travel.id">
                <TravelHomeCardComponent
                  :participation="participation"
                />
                </div>
              </div>
              <div class="mt-5 ms-3" v-else>
                <p class="card-text">Aucun événement à venir...</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3" v-if="historyParticipations.length > 0">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title text-center">Historique de mes événements</h4>
              <div class="card-text text-center text-md-start d-flex flex-wrap">
                <div class="col-12 col-md-6 col-lg-4 col-xl-3 my-2 m-md-0 d-flex flex-wrap p-2" v-for="participation in historyParticipations" :key="participation.travel.id">
                <TravelHomeCardComponent
                  :participation="participation"
                />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </PageView>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from 'vue';
import travelApi from '@/api/travelApi'
import PageView from '@/views/PageView.vue';
import TravelHomeCardComponent from '@/components/home/TravelHomeCardComponent.vue';
import { useNotificationsStore } from '@/stores/notificationStore';
const notificationsStore = useNotificationsStore();

const loading = ref(true);
const participations = ref<UserParticipationBasic[]>([]);

const activeParticipations = computed(() => {
  return participations.value.filter(participation => participation.travel.endDate > new Date() && participation.invitation?.refusalDate == null);
});

const historyParticipations = computed(() => {
  return participations.value.filter(participation => participation.travel.endDate <= new Date() || participation.invitation?.refusalDate != null);
});

onMounted(() => {
  travelApi.getCurrentUserParticipations().then((response) => {
    participations.value = response.data.items;
  }).catch((error: Error) => {
    notificationsStore.notifyError('Erreur lors du chargement de la page',error.message);
  }).finally(() => {
    loading.value = false;
  });
});

</script>
